import * as React from 'react';

import PropTypes from 'prop-types';

export class FunnelReportTotals extends React.Component {
    static propTypes = {
        meta: PropTypes.shape({
            count: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }).isRequired,
            amount: PropTypes.shape({
                value: PropTypes.number.isRequired,
                prefix: PropTypes.string.isRequired,
                formatted: PropTypes.string.isRequired,
                suffix: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    };

    render() {
        const {meta} = this.props;

        return (
            <span title={meta.amount ? meta.amount.value.toLocaleString() : undefined}>
                <span className='ui-funnel-report__meta__count'>{meta.count.value} leads</span>
                <span className='ui-funnel-report__meta__value'>
                    {' '}
                    valued at {meta.amount.prefix}
                    {meta.amount.formatted}
                    {meta.amount.suffix}
                </span>
            </span>
        );
    }
}
